
import { computed, defineComponent, ref } from "vue";
import CollapseTransition from "@ivanv/vue-collapse-transition/src/CollapseTransition";
import { useStore } from "@/stores/main";
import SvgIcon from "@jamescoyle/vue-icon";
import { Link } from "@inertiajs/inertia-vue3";
import Button from "../Buttons/Button.vue";
import {
  mdiAccount,
  mdiAccountGroup,
  mdiArrowExpandRight,
  mdiCalculator,
  mdiCart,
  mdiChartLine,
  mdiClockTimeEightOutline, mdiFileDocument, mdiFrequentlyAskedQuestions,
  mdiHome,
  mdiLogout,
  mdiViewModule,
} from "@mdi/js";

interface OpenParents {
  overview: boolean;
  cashRegister: boolean;
  customers: boolean;
  timeSheet: boolean;
  products: boolean;
  faqs: boolean;
  rfps: boolean;
  reports: boolean;
  registry: boolean;
  users: boolean;
}

export default defineComponent({
  methods: {

  },

  components: {
    Link,
    Button,
    SvgIcon,
    CollapseTransition,
  },
  props: {
    isSmall: {
      type: Boolean,
      default: () => false,
    },
  },
  setup(props) {
    const getInitParents = (): OpenParents => {
      return {
        overview: false,
        cashRegister: false,
        customers: false,
        timeSheet: false,
        products: false,
        faqs: false,
        rfps: false,
        reports: false,
        registry: false,
        users: false,
      };
    };

    const link = (routeName: string) => {
      return route(routeName);
    };

    const openParents = ref(getInitParents());

    const open = (section: string, prevValue: boolean) => {
      openParents.value = getInitParents();
      openParents.value[section as keyof OpenParents] = !prevValue;
    };

    const classes = computed(() => {
      return {
        small: props.isSmall,
      };
    });

    const store = useStore();

    const toggleNavSize = () => {
      store.navIsSmall = !store.navIsSmall;
    };

    return {
      link,
      open,
      store,
      classes,
      openParents,
      toggleNavSize,
      isAdmin: store.isAdmin,
      homeIcon: mdiHome,
      cartIcon: mdiCart,
      mdiFileDocument,
      customerIcon: mdiAccountGroup,
      clockIcon: mdiClockTimeEightOutline,
      productsIcon: mdiViewModule,
      reportsIcon: mdiChartLine,
      registryIcon: mdiCalculator,
      usersIcon: mdiAccount,
      logoutIcon: mdiLogout,
      expandIcon: mdiArrowExpandRight,
      mdiFrequentlyAskedQuestions
    };
  },
});
